import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <h1 className="about-title">About Me</h1>
        <div className="about-content">
          <div className="about-text">
            <p>
              I'm a passionate Computer Science student with a strong foundation in programming 
              and graphic design. My journey in CS and design
              equipped me with skills in multiple programming languages and design tools.
            </p>
            <p>
              I'm particularly interested in software development, web technologies, and 
              creating applications with a user first mindset.
            </p>
            <p>
              Currently seeking internship opportunities where I can apply my skills, 
              work on a team, and grow as a developer.
            </p>
          </div>
          <div className="skills">
            <h3>Technical Skills</h3>
            <div className="skills-grid">
              <div className="skill-category">
                <h4>Programming Languages</h4>
                <div className="skill-tags">
                  <span className="skill-tag">JavaScript</span>
                  <span className="skill-tag">C#</span>
                  <span className="skill-tag">Python</span>
                  <span className="skill-tag">Java</span>
                  <span className="skill-tag">C++</span>
                  <span className="skill-tag">SQL</span>
                </div>
              </div>
              <div className="skill-category">
                <h4>Web Technologies and Frameworks</h4>
                <div className="skill-tags">
                  <span className="skill-tag">React</span>
                  <span className="skill-tag">HTML/CSS</span>
                  <span className="skill-tag">Django</span>
                  <span className="skill-tag">FastAPI</span>
                  <span className="skill-tag">QT</span>
                </div>
              </div>
              <div className="skill-category">
                <h4>Design Tools</h4>
                <div className="skill-tags">
                  <span className="skill-tag">Adobe Photoshop</span>
                  <span className="skill-tag">Adobe Illustrator</span>
                  <span className="skill-tag">Adobe After Effects</span>
                  <span className="skill-tag">Adobe Premiere Pro</span>
                  <span className="skill-tag">Figma</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
